import { Box, Text } from 'ink';
import SelectInput from '../../../components/SelectInput';
import CustomSelectInputIndicator from '../../../components/CustomSelectInputIndicator';
import CustomSelectInputItem from '../../../components/CustomSelectInputItem';
import useExit from '../../../utilities/useExit';

import type { JSX } from 'react';

export default function YesNoConfirmation({
  onYes,
  title,
  footer = 'Your users will be auto-updated to this version. You can use ' +
    '--force to bypass this confirmation in future',
}: {
  onYes: () => void;
  title: string | JSX.Element;
  footer?: string;
}) {
  const exit = useExit();

  const items = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ];

  function onSelect(item: { value: string }) {
    if (item.value === 'yes') {
      onYes();
    } else if (item.value === 'no') {
      setTimeout(() => exit(), 10);
    }
  }

  return (
    <Box flexDirection="column">
      <Box>{typeof title === 'string' ? <Text>{title}</Text> : title}</Box>

      <Box marginBottom={1} marginTop={1}>
        <SelectInput
          indicatorComponent={CustomSelectInputIndicator}
          initialIndex={1}
          itemComponent={CustomSelectInputItem}
          items={items}
          onSelect={onSelect}
        />
      </Box>

      <Text dimColor>{footer}</Text>
    </Box>
  );
}
